import { useEffect, useState } from "react";
import { toast } from "sonner";
import * as LucideIcons from "lucide-react";
import { Loader2, ChevronUp, ChevronDown } from "lucide-react";
import { api } from "../lib/api";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/categories").then(r => { setCats(r.data); setLoading(false); });

  useEffect(() => { load(); }, []);

  const move = async (idx, dir) => {
    const newIdx = idx + dir;
    if (newIdx < 0 || newIdx >= cats.length) return;
    const a = cats[idx], b = cats[newIdx];
    const items = [
      { category_id: a.category_id, order_position: b.order_position },
      { category_id: b.category_id, order_position: a.order_position },
    ];
    await api.post("/admin/categories/reorder", { items });
    load();
  };

  const toggle = async (cat) => {
    await api.patch(`/admin/categories/${cat.category_id}`, { is_active: !cat.is_active });
    toast.success(cat.is_active ? "Désactivée." : "Activée.");
    load();
  };

  return (
    <div data-testid="admin-categories-page">
      <h1 className="text-[32px] font-bold mb-2" style={{ fontFamily: "'Sora', sans-serif" }}>Admin — Catégories</h1>
      <p className="text-sm mb-6" style={{ color: "#666" }}>Réservé CEO/Direction. Réordonnez avec les flèches.</p>
      {loading && <Loader2 className="animate-spin" color="#F77F00" />}
      <div className="bg-white rounded-[12px] overflow-hidden" style={{ border: "1px solid #E5E5E5" }}>
        {cats.map((c, idx) => {
          const Ic = LucideIcons[c.icon] || LucideIcons.Tag;
          return (
            <div key={c.category_id} className="flex items-center gap-4 px-4 py-3 border-b last:border-b-0"
              style={{ borderColor: "#E5E5E5", opacity: c.is_active ? 1 : 0.5 }}
              data-testid={`admin-cat-${c.code}`}>
              <div className="flex flex-col">
                <button onClick={() => move(idx, -1)} className="p-1" data-testid={`admin-cat-up-${c.code}`}><ChevronUp size={14} /></button>
                <button onClick={() => move(idx, 1)} className="p-1" data-testid={`admin-cat-down-${c.code}`}><ChevronDown size={14} /></button>
              </div>
              <Ic size={20} color={c.color} />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm">{c.label_fr}</div>
                <div className="text-xs" style={{ color: "#666" }}>{c.label_en} · {c.family} · pos {c.order_position}</div>
                {c.allowed_levels && <div className="text-xs mt-0.5" style={{ color: "#999" }}>Niveaux: {c.allowed_levels.join(", ")}</div>}
              </div>
              <button onClick={() => toggle(c)}
                data-testid={`admin-cat-toggle-${c.code}`}
                className="px-3 py-1 rounded-full text-xs font-semibold"
                style={{ background: c.is_active ? "#D1FAE5" : "#FEE2E2", color: c.is_active ? "#065F46" : "#991B1B" }}>
                {c.is_active ? "Active" : "Inactive"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
